import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { Dropdown } from "semantic-ui-react"
import { useEffect, useState } from "react"
import { navigationPaths } from "../../constants/paths"
import { TiresBottomNav } from "../../layouts/TiresLayout"
import { SUCCESS } from "../../constants/tires"
import CustomNotification from "../../components/shared/CustomNotification"
import { gaJSON, trackFirebaseAnalytics } from "../../helpers/googleAnalyticsHelpers"

const SelectTireSize = ({ step, vehicle, dispatch, history, user }) => {
  const [rimSizeOptions, setRimSizeOptions] = useState([])
  const [seasonOptions, setSeasonOptions] = useState([])
  const [speedRateOptions, setSpeedRateOptions] = useState([])
  const [loadIndexOptions, setLoadIndexOptions] = useState([])

  const [selectedRim, setSelectedRim] = useState(null)
  const [selectedSeason, setSelectedSeason] = useState(null)
  const [selectedSpeedRate, setSelectedSpeedRate] = useState(null)
  const [selectedLoadIndex, setSelectedLoadIndex] = useState(null)

  const [filtersLoading, setFiltersLoading] = useState(false)

  if (!vehicle) {
    return <></>
  }

  const continueClick = () => {
    const rim = JSON.parse(selectedRim)
    trackFirebaseAnalytics({
      event: gaJSON.find_tires_clicked,
      params: {
        vehicle_id: vehicle.id,
        user_role: user.roles.toString()
      }
    })
    dispatch({ type: "TIRES_SET_RIM", payload: { rim: rim } })
    dispatch({
      type: "TIRES_SET_FILTERS",
      payload: {
        filters: {
          season: {
            checkbox: selectedSeason ? [selectedSeason] : []
          },
          speed_rating: {
            checkbox: selectedSpeedRate ? [selectedSpeedRate] : []
          },
          load_index: {
            checkbox: selectedLoadIndex ? [selectedLoadIndex] : []
          }
        }
      }
    })
    history.push({
      pathname: navigationPaths["selectTire"]()
    })
  }

  useEffect(() => {
    dispatch({
      type: "GET_RIM_SIZE_SAGA",
      payload: {
        vehicleId: vehicle.id
      },
      callback: (res, data) => {
        if (res === SUCCESS) {
          if (!data.rim_sizes) return
          const options = data?.rim_sizes?.map((item) => {
            const key = Object.keys(item)[0]
            return {
              key: key,
              text: key,
              value: JSON.stringify({ key: key, value: [...item[key]] })
            }
          })
          setRimSizeOptions(options)
        } else {
          return CustomNotification("danger", "Error", data.error)
        }
      }
    })
  }, [vehicle])

  const handleRimChange = (e, { value }) => {
    setSelectedRim(value)
  }
  useEffect(() => {
    dispatch({
      type: "TIRE_CART_ITEM",
      payload: {
        cartTireObject: null,
        tireQuantity: 0
      }
    })
  }, [])
  useEffect(() => {
    if (!selectedRim) return
    const rim = JSON.parse(selectedRim)
    const cartireids = rim.value

    setFiltersLoading(true)

    setLoadIndexOptions([])
    setSpeedRateOptions([])
    setSeasonOptions([])

    setSelectedLoadIndex(null)
    setSelectedSpeedRate(null)
    setSelectedSeason(null)

    dispatch({
      type: "GET_FILTERED_LIST_OF_TIRES_SAGA",
      payload: { cartireids: cartireids },
      callback: (res, data) => {
        if (res === SUCCESS) {
          const filters = data.filters
          if (!filters) return
          if (!filters?.season) {
            CustomNotification(
              "danger",
              "Error",
              "Uh oh! We may not have any tires in this size. Please select a different size, or call your local shop to check inventory and book an appointment for 'New Tires'."
            )
            setFiltersLoading(false)
            return
          }
          setLoadIndexOptions(convertArrayToKeyObjects(filters.load_index))
          setSpeedRateOptions(convertArrayToKeyObjects(filters.speed_rating))
          setSeasonOptions(convertArrayToKeyObjects(filters.season))
        } else {
          CustomNotification("danger", "Error", data.error)
        }
        setFiltersLoading(false)
      }
    })
  }, [selectedRim])

  function convertArrayToKeyObjects(array) {
    return array?.map
      ? array.map((item) => ({
          key: item,
          text: item,
          value: item
        }))
      : []
  }

  const continueDisabled = () => {
    return selectedRim && !filtersLoading
  }

  return (
    <>
      <div className="max-w-[700px] mx-auto mt-5 px-[10px] mb-[100px]">
        <h2 className="text-lg font-semibold mb-4 text-center tires-step-header">
          Step {step.step} / 6: Select Tire Size
        </h2>
        <div className="w-full p-6 bg-white rounded-xl shadow grid md:grid-cols-2 gap-10 text-black">
          <div>
            <p className="text-3xl font-semibold !text-black m-0 !mb-3">Select your tire size</p>
            <p className="text-xl font-semibold m-0 !text-black">
              Vehicle {vehicle.other_id || "N/A"}
            </p>
            <p className="text-xl">{vehicle?.name}</p>

            <div className="flex flex-col mb-5">
              <label form="size" className="font-semibold">
                Tire Size <span className="text-red-800">*</span>
              </label>
              <Dropdown
                placeholder="Select"
                selection
                options={rimSizeOptions}
                value={selectedRim}
                onChange={handleRimChange}
              />
            </div>
            <div className="flex flex-col mb-5">
              <label form="size" className="font-semibold">
                Season <span className="font-normal">(Optional)</span>
              </label>
              <Dropdown
                placeholder="Select"
                search
                selection
                options={seasonOptions}
                loading={filtersLoading}
                value={selectedSeason}
                onChange={(e, { value }) => setSelectedSeason(value)}
                clearable
              />
            </div>
            <div className="flex flex-col mb-5">
              <label form="size" className="font-semibold">
                Speed Rating <span className="font-normal">(Optional)</span>
              </label>
              <Dropdown
                placeholder="Select"
                search
                selection
                options={speedRateOptions}
                loading={filtersLoading}
                value={selectedSpeedRate}
                onChange={(e, { value }) => setSelectedSpeedRate(value)}
                clearable
              />
            </div>
            <div className="flex flex-col">
              <label form="size" className="font-semibold">
                Load Index <span className="font-normal">(Optional)</span>
              </label>
              <Dropdown
                placeholder="Select"
                search
                selection
                options={loadIndexOptions}
                loading={filtersLoading}
                value={selectedLoadIndex}
                onChange={(e, { value }) => setSelectedLoadIndex(value)}
                clearable
              />
            </div>
          </div>
          <div className="m-auto">
            <img alt="Tire Size" src="/images/tire-size.png" />
          </div>
        </div>
      </div>
      <TiresBottomNav
        next={continueClick}
        nextDisabled={continueDisabled()}
        goBack={() => history.goBack()}
      />
    </>
  )
}

function mapStateToProps(state) {
  return {
    vehicle: state.tires.vehicle,
    user: state.application.userSessionData || (state.users && state.users.currentUser)
  }
}

export default connect(mapStateToProps)(withTranslation("shops")(SelectTireSize))
